import { usePostFrontTipiDomandaIdRichieste } from '@framework/api-client/api/inquiries-compile/domande-controller/domande-controller.ts';
import { type CollegamentoRichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/collegamentoRichiestaDTO.ts';
import { getNetworkErrorMessage } from '@framework/auth/http/errors/getNetworkErrorMessage.ts';
import { message } from 'antd';
import { useCallback, useState } from 'react';

export function useCreateSubmission(params: {
  inquiryId: string | null | undefined;
  links?: CollegamentoRichiestaDTO[];
}) {
  const { inquiryId, links } = params;

  const createSubmissionHook = usePostFrontTipiDomandaIdRichieste({
    mutation: {
      onError: error => {
        console.error(`[createRequest] Error: `, { error });
        message.error(getNetworkErrorMessage(error));
      },
    },
  });

  const [loading, setLoading] = useState(false);

  const createSubmission = useCallback(async () => {
    if (!inquiryId) return null;
    setLoading(true);

    try {
      const result = await createSubmissionHook.mutateAsync({
        idTipoDomanda: inquiryId,
        data: {
          collegamenti: links ?? [],
        },
      });
      return result;
    } finally {
      setLoading(false);
    }
  }, [createSubmissionHook, inquiryId]);

  return { createSubmission, loading };
}
